import React from 'react';
import RedirectSessionSearchOrPartnerSearch from './RedirectSessionSearchOrPartnerSearch';

const RedirectPartnerSearch = (...props) => <RedirectSessionSearchOrPartnerSearch isSessionSearch={false} {...props} />;

export default RedirectPartnerSearch;
